import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import zhTW from 'antd/locale/zh_TW';
import { QueryClient, QueryClientProvider } from 'react-query';

// Layouts
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';

// Pages
import Login from './pages/Auth/Login';
import Dashboard from './pages/Dashboard';
import QuotationList from './pages/Quotation/QuotationList';
import QuotationCreate from './pages/Quotation/QuotationCreate';
import QuotationDetail from './pages/Quotation/QuotationDetail';
import QuotationOCR from './pages/Quotation/QuotationOCR';
import CustomerList from './pages/Customer/CustomerList';
import ProductList from './pages/Product/ProductList';
import OrderList from './pages/Order/OrderList';
import Settings from './pages/Settings';

// Hooks
import { useAuthStore } from './stores/authStore';

// Styles
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// 受保護路由元件
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        locale={zhTW}
        theme={{
          token: {
            colorPrimary: '#1890ff',
            borderRadius: 4,
          },
          algorithm: theme.defaultAlgorithm,
        }}
      >
        <BrowserRouter>
          <Routes>
            {/* 認證路由 */}
            <Route path="/login" element={<AuthLayout><Login /></AuthLayout>} />
            
            {/* 主要應用路由 */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              
              {/* 報價單 */}
              <Route path="quotations">
                <Route index element={<QuotationList />} />
                <Route path="create" element={<QuotationCreate />} />
                <Route path="ocr" element={<QuotationOCR />} />
                <Route path=":id" element={<QuotationDetail />} />
              </Route>
              
              {/* 訂單 */}
              <Route path="orders">
                <Route index element={<OrderList />} />
              </Route>
              
              {/* 客戶 */}
              <Route path="customers">
                <Route index element={<CustomerList />} />
              </Route>
              
              {/* 商品 */}
              <Route path="products">
                <Route index element={<ProductList />} />
              </Route>
              
              {/* 設定 */}
              <Route path="settings" element={<Settings />} />
            </Route>
            
            {/* 404 */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
